import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

export default class DashboardRoute extends Route 
{
	@service resultsAjax;
	@service store;
	
	model(params)
	{
		var event_id = this.modelFor('event').id;

		var store = this.store;

		return this.resultsAjax.request("/events/"+event_id+"/results/individuals").then(function(results)
		{
			results.forEach(function(result)
			{
				store.pushPayload(result);
			});
		}).then(function()
		{
			return store.findRecord('Event', event_id);
		});
	};
	
	@action
	async refreshModel()
	{
		var event_id = this.modelFor('event').id;
		let resultsJSON = await this.resultsAjax.request("/events/"+event_id+"/results/individuals");
		for(let result of resultsJSON)
		{
			this.store.pushPayload(result);
		}
	};
}
